import { FileText, LayoutDashboard, Library } from "lucide-react";
import { Button } from "@/components/ui/button";
import { portalHref } from "./portal-href";
import type { PaymentCallbackStatus } from "./payment-copy";

interface PaymentCallbackActionsProps {
  status: PaymentCallbackStatus;
  invoiceId: string | null;
  portalBaseUrl: string | null;
  digitalResource: boolean;
  digitalResourceId: string | null;
}

export function PaymentCallbackActions({
  status,
  invoiceId,
  portalBaseUrl,
  digitalResource,
  digitalResourceId,
}: PaymentCallbackActionsProps) {
  if (status === "verifying") return null;

  const receiptHref =
    status === "success" && invoiceId
      ? portalHref(portalBaseUrl, `/invoices/${invoiceId}/receipt`)
      : null;
  const resourceHref =
    status === "success" && digitalResource && digitalResourceId
      ? portalHref(portalBaseUrl, `/paid-resources/${digitalResourceId}`)
      : null;

  return (
    <div className="flex w-full flex-col gap-3">
      {resourceHref ? (
        <Button asChild size="lg" className="h-12 w-full duration-300 ease-out">
          <a href={resourceHref}>
            <Library className="mr-2 h-4 w-4" aria-hidden />
            Open resource
          </a>
        </Button>
      ) : null}
      {receiptHref ? (
        <Button
          asChild
          size="lg"
          variant={resourceHref ? "outline" : "default"}
          className="h-12 w-full duration-300 ease-out"
        >
          <a href={receiptHref}>
            <FileText className="mr-2 h-4 w-4" aria-hidden />
            View receipt
          </a>
        </Button>
      ) : null}
      {status === "success" && digitalResource ? (
        <Button asChild size="lg" variant="outline" className="h-12 w-full duration-300 ease-out">
          <a href={portalHref(portalBaseUrl, "/paid-resources")}>
            <Library className="mr-2 h-4 w-4" aria-hidden />
            All paid resources
          </a>
        </Button>
      ) : null}
      <Button
        asChild
        size="lg"
        variant={receiptHref || resourceHref ? "outline" : "default"}
        className="h-12 w-full duration-300 ease-out"
      >
        <a href={portalHref(portalBaseUrl, "/invoices")}>
          <Library className="mr-2 h-4 w-4" aria-hidden />
          My invoices
        </a>
      </Button>
      <Button asChild size="lg" variant="ghost" className="h-12 w-full duration-300 ease-out">
        <a href={portalHref(portalBaseUrl, "/dashboard")}>
          <LayoutDashboard className="mr-2 h-4 w-4" aria-hidden />
          Dashboard
        </a>
      </Button>
    </div>
  );
}
